import { atom } from 'jotai';

export const isSelectedQuestPanelInQuestLogOpenAtom = atom(false);
export const setIsSelectedQuestPanelInQuestLogOpenAtom = atom(null, (_get, set, payload: boolean) => {
	set(isSelectedQuestPanelInQuestLogOpenAtom, payload);
});

export const isSelectedQuestPanelInQuestLogActiveAtom = atom(false);
export const setIsSelectedQuestPanelInQuestLogActiveAtom = atom(null, (_get, set, payload: boolean) => {
	set(isSelectedQuestPanelInQuestLogActiveAtom, payload);
});

export const resetJournalQuestLogStoreAtom = atom(null, (_get, set) => {
	set(isSelectedQuestPanelInQuestLogOpenAtom, false);
	set(isSelectedQuestPanelInQuestLogActiveAtom, false);
});
